module.exports = __webpack_public_path__ + "c32f630b35ea66c80a7355a03e761606.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/react-html5video/src/assets/font/video-fontello.ttf?1445970113105
// module id = 1434
// module chunks = 0